import { Row } from "antd";
import Title from "antd/lib/typography/Title";
import React from "react";
import { styled } from "styled-components";
import { useSocialServiceContext } from "../Context";
import { format, parseISO } from "date-fns";
import * as CurrencyFormat from "react-currency-format";

const HistoryContainer = styled(Row)`
  .fullWidth {
    width: 100%;

    
    @media only screen and (min-width: 900px) {
      color: #FFF;
      span {
        color: #FFF;
      }
    }
  }
`;
const ProgramName = styled.p`
  color: #000;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  margin-bottom: 0px;
  @media only screen and (min-width: 900px) {
    color: #FFF;
  }
`;

const AgencyAcronym = styled.span`
  color: #107400;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  @media only screen and (min-width: 900px) {
    color: #FFF;
  }
`;

const SocialServiceDate = styled.span`
  color: #000;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  @media only screen and (min-width: 900px) {
    color: #FFF;
  }
`;

const SocialServiecProposedAmount = styled.span`
  color: #000;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  @media only screen and (min-width: 900px) {
    color: #FFF;
  }
`;

const ProgramDetail = styled.div`
  display: flex; /* Use flexbox for layout */
  align-items: center; /* Vertically center the child elements */
  flex-wrap: wrap; /* Allow the items to wrap as needed */
  @media only screen and (min-width: 900px) {
    color: #FFF;
  }
`;
const StyledTitle = styled(Title)`
  @media only screen and (min-width: 700px) {
    color: white !important;
  }
`;

const HistoryItem = ({
  citizen_program_id,
  proposed_amount,
  created_at,
  agency,
  program: { id, name },
  overrides,
  program_type,
}) => {
  const renderProposedAmount = () => {
    if (proposed_amount) {
      return (
        <CurrencyFormat
          thousandSeparator={true}
          displayType={"text"}
          prefix={"₱"}
          value={proposed_amount}></CurrencyFormat>
      );
    }


    switch (program_type) {
      case 1: {
        return (
          <CurrencyFormat
            thousandSeparator={true}
            displayType={"text"}
            prefix={"₱"}
            value={proposed_amount}></CurrencyFormat>
        );
      }
      case 2: {
        return overrides?.details || "No Details";
      }
      case 3: {
        return "Attendance";
      }
      default: {
        return "No Proposed Amount";
      }
    }
  };

  return (
    <HistoryContainer className="fullWidth" key={citizen_program_id}>
      <ProgramName className="fullWidth">{id !== 110 ? name : overrides?.program}</ProgramName>
      <ProgramDetail>
        <AgencyAcronym>{agency.id !== 33 ? agency.acronym : overrides.agency}</AgencyAcronym>-
        <SocialServiceDate>{format(parseISO(created_at), "MMMM d, yyyy h:mma")}</SocialServiceDate>
      </ProgramDetail>
      <SocialServiecProposedAmount className="fullWidth">{renderProposedAmount()}</SocialServiecProposedAmount>
    </HistoryContainer>
  );
};

const History = () => {
  const { history: histories } = useSocialServiceContext();

  return (
    <>
      <Row>
        <StyledTitle level={3}>Social Service History</StyledTitle>
      </Row>
      {histories?.map(item => (
        <HistoryItem key={item.citizen_program_id} {...item} />
      ))}
    </>
  );
};

export default History;
